/**
 * Client-runtime context shared by telemetry and error-log emitters.
 *
 * Centralized so both modules attach identical platform/version metadata.
 */

export const APP_VERSION = process.env.APP_VERSION || "0.0.0";

export function getExcelPlatform(): string {
  try {
    const p = (window as { Office?: typeof Office }).Office?.context?.platform;
    if (p === undefined || p === null) return "UNKNOWN";
    switch (p) {
      case Office.PlatformType.PC:
        return "WIN32";
      case Office.PlatformType.Mac:
        return "MAC";
      case Office.PlatformType.OfficeOnline:
        return "WEB";
      case Office.PlatformType.iOS:
        return "IOS";
      case Office.PlatformType.Android:
        return "ANDROID";
      default:
        return "UNKNOWN";
    }
  } catch {
    return "UNKNOWN";
  }
}

export function getOfficeVersionBucket(): string {
  try {
    const v = (window as { Office?: typeof Office }).Office?.context
      ?.diagnostics?.version;
    if (!v) return "UNKNOWN";
    const major = v.split(".")[0];
    if (!major) return "UNKNOWN";
    return `16_${major}`;
  } catch {
    return "UNKNOWN";
  }
}
